<svg [@visible]="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 403 259">
  <defs>
    <filter id="Rectangle_14" x="0" y="0" width="403" height="259" filterUnits="userSpaceOnUse">
      <feOffset dy="3" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="3" result="blur"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
  </defs>
  <g id="Dashboard1" transform="translate(-463 -263)">
    <g transform="matrix(1, 0, 0, 1, 463, 263)" filter="url(#Rectangle_14)">
      <rect id="Rectangle_14-2" data-name="Rectangle 14" width="385" height="241" rx="10" transform="translate(9 6)" fill="#fafafa"/>
    </g>
    <text id="Dashboard" transform="translate(494 303)" fill="#88a3fb" font-size="20" font-family="SegoeUI, Segoe UI" letter-spacing="0.05em"><tspan x="0" y="0">Dashboard</tspan></text>
    <g id="button" transform="translate(18 -10)">
      <rect id="Rectangle_18" data-name="Rectangle 18" width="99" height="20" rx="5" transform="translate(720 297)" fill="#88a3fb"/>
      <path id="Polygon_1" data-name="Polygon 1" d="M4,0,8,6H0Z" transform="translate(814 311) rotate(180)" fill="#fff"/>
    </g>
    <rect id="Rectangle_15" data-name="Rectangle 15" width="339" height="141" rx="10" transform="translate(494 342)" fill="#fff"/>
    <rect id="Rectangle_40" data-name="Rectangle 40" width="81" height="10" rx="5" transform="translate(507 353)" fill="#9ea8c9"/>

    <g id="graph-week" transform="translate(77 -387.658)">
      <path id="Path_10" data-name="Path 10" d="M6660.347,854.042s28-32.947,44.062-36.34,35.122.17,53.909,0,45.74,3.911,58.809,0,31.038-12.63,45.468-22.941S6888.732,770.7,6906.7,770.7s49.734,47,49.734,47" transform="translate(-6220)" fill="none" stroke="#88a3fb" stroke-width="2"/>
      <g id="Ellipse_15" data-name="Ellipse 15" transform="translate(476 813.658)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_16" data-name="Ellipse 16" transform="translate(436 849.658)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_17" data-name="Ellipse 17" transform="translate(533 813.658)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_18" data-name="Ellipse 18" transform="translate(596 811.658)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_19" data-name="Ellipse 19" transform="translate(637 790.658)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_20" data-name="Ellipse 20" transform="translate(682 766.658)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_21" data-name="Ellipse 21" transform="translate(731 811.658)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
    </g>

    <g id="graph-month" data-name="Group 27" transform="translate(-404 -452)">
      <path id="Path_11" data-name="Path 11" d="M7139.345,867.342s9.97,16.407,17.195,31.238,11.257,18.6,18.569,20.744,13.24,0,26.479,0h51.583c13.326,0,19.835,1.96,28.2,0s15.267-14.109,21.321-20.744,9.985-11.049,19.945-13.179,15.033-1.662,22.353,0,17.518,13.179,23.383,13.179,9.714-13.179,19.257-13.179,14.6,13.179,18.914,13.179,9.973-5.369,19.257-13.179a170.674,170.674,0,0,0,17.882-18.06" transform="translate(-6223 -11)" fill="none" stroke="#88a3fb" stroke-width="2"/>
      <g id="Ellipse_22" data-name="Ellipse 22" transform="translate(912 852)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_23" data-name="Ellipse 23" transform="translate(926 876)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_24" data-name="Ellipse 24" transform="translate(947 903)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_25" data-name="Ellipse 25" transform="translate(975 903)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_26" data-name="Ellipse 26" transform="translate(1029 903)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_27" data-name="Ellipse 27" transform="translate(1053 903)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_28" data-name="Ellipse 28" transform="translate(1071 889)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_29" data-name="Ellipse 29" transform="translate(1088 872)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_30" data-name="Ellipse 30" transform="translate(1116 869)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_31" data-name="Ellipse 31" transform="translate(1140 883)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_32" data-name="Ellipse 32" transform="translate(1160 869)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_33" data-name="Ellipse 33" transform="translate(1179 883)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_34" data-name="Ellipse 34" transform="translate(1199 869)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_35" data-name="Ellipse 35" transform="translate(1217 853)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
      <g id="Ellipse_36" data-name="Ellipse 36" transform="translate(1003 903)" fill="#fff" stroke="#88a3fb" stroke-width="2">
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none"/>
        <circle cx="4.5" cy="4.5" r="3.5" fill="none"/>
      </g>
    </g>

    <g id="toggle-week" transform="translate(78 -410)">
      <text id="past" transform="translate(690 771)" fill="#707070" font-size="10" font-family="Inter var, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'" letter-spacing="0.05em"><tspan x="0" y="0">past</tspan></text>
      <text id="week" transform="translate(714 771)" fill="#88a3fb" font-size="10" font-family="Inter var, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'" font-weight="700" letter-spacing="0.05em"><tspan x="0" y="0">week</tspan></text>
    </g>

    <g id="toggle-month" data-name="Group 26" transform="translate(77 -410)">
      <text id="past" transform="translate(686 771)" fill="#707070" font-size="10" font-family="Inter var, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'" letter-spacing="0.05em"><tspan x="0" y="0">past</tspan></text>
      <text id="month" transform="translate(710 771)" fill="#88a3fb" font-size="10" font-family="Inter var, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'" letter-spacing="0.05em"><tspan x="0" y="0">month</tspan></text>
    </g>

  </g>
</svg>
